var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.69231C2 8.66667 4 8.66667 4 9.69231L4 17.8974C4 19.0303 4.89543 19.9487 6 19.9487L18 19.9487C19.1046 19.9487 20 19.0303 20 17.8974L20 9.69231C20 8.66667 22 8.66667 22 9.69231L22 17.8974C22 20.1632 20.2091 22 18 22L6 22C3.79086 22 2 20.1632 2 17.8974L2 9.69231Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2995 17.0909C11.3938 17.1859 11.5019 17.2579 11.6172 17.3068C11.7343 17.3566 11.8625 17.3842 11.997 17.3846L12 17.3846L12.003 17.3846C12.2579 17.3838 12.5126 17.2837 12.7071 17.0842L15.7071 14.0073C16.0976 13.6067 16.0976 12.9574 15.7071 12.5568C15.3166 12.1563 14.6834 12.1563 14.2929 12.5568L13 13.8829L13 3.02564C13 2.45919 12.5523 2 12 2C11.4477 2 11 2.45919 11 3.02564L11 13.8829L9.70711 12.5568C9.31658 12.1563 8.68342 12.1563 8.29289 12.5568C7.90237 12.9574 7.90237 13.6067 8.29289 14.0073L11.2922 17.0835L11.2995 17.0909Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.d2f9f800405d9bab8729a32a1aadae50.svg";
export { ForwardRef as ReactComponent };